import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'État',
      fields: {
        delivery_visible: {
          label: 'Livraison visible',
        },
        has_delivery: {
          label: 'Livraison',
        },
        delivery_enabled: {
          label: 'Livraison en direct',
        },
      },
    },
    delivery_mode: {
      title: 'Mode de livraison',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Flotte de livreurs du restaurant',
            [DeliveryMode.External]: 'Flotte de livreurs externe ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Note de collecte pour le livreur',
          placeholder: "Informations utiles pour le livreur (ex. : comment trouver l'entrée, etc.)",
        },
        instant_print_enabled: {
          label: 'Imprimer le ticket sans attendre le livreur',
        },
        provider_not_connected: {
          wolt_drive: "Pas encore connecté : ce restaurant n'a pas d'ID de site Wolt valide.",
          connects_on_external:
            '{{provider}} est connecté une fois que le mode de livraison est défini sur livreurs externes et enregistré.',
          not_connected_yet:
            "{{provider}} n'est pas encore connecté pour ce restaurant. Si cela ne change pas, veuillez contacter le support.",
        },
      },
    },
    scheduled_orders: {
      title: 'Commandes planifiées',
      fields: {
        has_scheduled_orders: {
          label: "Autorisez-vous vos clients à commander à l'avance pour des horaires précis ?",
        },
        min_schedule_ahead_time_delivery: {
          label: "Délai minimum (minutes) à l'avance pour planifier des commandes en <strong>livraison</strong>",
          placeholder: '60',
          validation_name: 'Délai minimum de planification de livraison',
          external_hint: "Avec la livraison externe, ce délai doit être d'au moins {{minutes}} minutes (2 heures). ",
        },
        last_order_gap_delivery: {
          label: 'Dernière heure possible pour commander en <strong>livraison</strong> (minutes avant la fermeture)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Infos de livraison',
      fields: {
        average_order_delivery_time_min: {
          label: 'Délai de livraison',
          placeholder: 'Durée en minutes',
        },
        average_order_delivery_time_max: {
          label: 'à',
          placeholder: 'Optionnel',
        },
      },
    },
    delivery_zones: {
      title: 'Zones de livraison',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    at_least_one_order_method_required:
      'Au moins 1 méthode de commande (planifiée ou immédiate) doit être activée. Vous ne pouvez pas désactiver les deux.',
  },
};
